import * as React from 'react';
import { Icon } from '@roo/roo';
import { useHistory } from 'react-router-dom';
import utils from '../../utils/utils';
import { useGetRequest } from '@/hooks/use-request';
import {
    PunishmentStatusEnum,
    PunishmentTypeCnEnum,
    PunishmentTypeEnum,
    PunishStatusZH,
    PunishmentTargetEnum,
    PunishmentTargetCnEnum,
    PunishmentStatusCnEnum,
    PunishStatusEN,
} from './types';
import './index.scss';

interface PunishmentItemType {
    /** 处罚方式，1-下架，2-冻结，3-扣分 */
    type: PunishmentTypeEnum;
    /** 下架为0，冻结为天数，扣分为分数 */
    value: number;
}

const PunishmentTypeUnitCnEnumMap = {
    [PunishmentTypeEnum.TAKEOFF]: '',
    [PunishmentTypeEnum.FREEZE]: '天',
    [PunishmentTypeEnum.PENALTIES]: '分',
};

interface pagedResultItem {
    id: number;
    ctime: number;
    /** 处罚方式 */
    punishment: PunishmentItemType[];
    /** 处罚对象 */
    target: number;
    /** 服务商简称 */
    simpleProviderName: string;
    /** 服务名称 */
    itemName: string;
    /** 违规类型id */
    violationTypeId: number;
    /** 违规类型描述 */
    violationType: string;
    /** 违规内容id */
    violationContentId: number;
    /** 违规内容描述 */
    violationContent: string;
    /** 操作人 */
    operator: string;
    /** 处罚状态 */
    status: PunishmentStatusEnum;
}

interface serviceProviderScore {
    /** 服务商当前得分 */
    score: number;
    /** 惩罚状态 1：正常2：置休3：永久下架  */
    punishStatus: number;
    /** 冻结天数 只有punishStatus为:2的时候,此参数生效,其他状态此参数值为:0 */
    pauseDay: number;
    /** 恢复时间 yyyy-MM-dd hh:mm */
    releaseTime: string;
}

const tableColumns = [
    {
        key: 'ctime',
        label: '时间',
    },
    {
        key: 'punishment',
        label: '处罚方式',
    },
    {
        key: 'target',
        label: '违规对象',
    },
    {
        key: 'violationContent',
        label: '违规内容',
    },
    {
        key: 'status',
        label: '处罚状态',
    },
];
const Score: React.FC = () => {
    const history = useHistory();
    const { data: scoreHistory = [] } = useGetRequest<{}, pagedResultItem[]>(
        '/api/diagon/alley/punishment/record/list',
    );

    const {
        data: providerScore = {
            score: 12,
            punishStatus: 1,
            pauseDay: 0,
            releaseTime: '',
        },
    } = useGetRequest<{}, serviceProviderScore>('/api/serviceProvider/score');

    const normClick = () => {
        history.push('/norm', { onlyShow: 'true' });
    };

    return (
        <div className="page score">
            <div className="title">得分与服务商状态</div>
            <div className="info">
                <div className="title">
                    <Icon name="info-circle-o" size={22} color="rgb(119 155 249)" />
                    <span>
                        得分将直接影响服务商营业状态，请严格遵守
                        <a href="javascript:;" onClick={normClick}>
                            《美团外卖服务市场管理规范》
                        </a>
                    </span>
                </div>
                <div className="content">
                    <p>
                        1.
                        服务商初始得分12分，违反《美团外卖服务市场管理规范》将扣除相应分数，并作出相应处罚；
                    </p>
                    <p>2. 违规扣分在每个年度的最后一天24时清零；</p>
                    <p>
                        3.
                        服务商扣分满12分后若继续扣分累计，每增3分，均会处罚一次，每次均会按照12分档位处罚标准进行处罚。同时服务市场有权单方终止合作或收回部分类目经营权限；
                    </p>
                    <p>
                        4.服务商违规行为同时触发多个服务市场发布的违规处罚规则，则依据从严从重处罚叠加原则进行处罚。{' '}
                    </p>
                </div>
            </div>
            <div className="number-wrap">
                <div className="title">当前得分</div>
                <div className="content">
                    <div>
                        <span className="number">{providerScore.score}</span>
                        <span>分</span>
                    </div>
                    <div className="progress-bg">
                        <div
                            className="progress"
                            style={{ width: `${(providerScore.score / 12) * 240} + px` }}
                        />
                    </div>
                    <div>
                        <span>服务商状态：{PunishStatusZH[providerScore.punishStatus]}</span>
                        {providerScore.punishStatus !== PunishStatusEN.rest ? null : (
                            <span>
                                <span>{providerScore.pauseDay}天</span>
                                <span className="status">{providerScore.releaseTime} 恢复</span>
                            </span>
                        )}
                    </div>
                </div>
            </div>
            <div className="history">
                <div className="table">
                    <div className="thead">
                        <div className="tr">
                            {tableColumns.map((col, key) => (
                                <div className="td" key={key}>
                                    {col.label}
                                </div>
                            ))}
                        </div>
                    </div>

                    {scoreHistory.length <= 0 ? (
                        <div className="empty-history">
                            <img src="@/assets/images/empty-file.png" alt="" />
                            <p className="txt">没有处罚记录，继续保持哟~</p>
                        </div>
                    ) : (
                        <div className="tbody">
                            {scoreHistory.map(item => (
                                <div className="tr" key={item.id}>
                                    <div className="td">
                                        {utils.timestampToMinutes(item.ctime).date}
                                        {utils.timestampToMinutes(item.ctime).time}
                                    </div>
                                    <div className="td">
                                        {item.punishment.map(record => (
                                            <div key={record.type}>
                                                {`${PunishmentTypeCnEnum[record.type]}${
                                                    // eslint-disable-next-line
                                                    record.type !== PunishmentTypeEnum.PENALTIES
                                                        ? item.target ===
                                                          PunishmentTargetEnum.SERVICE
                                                            ? '服务'
                                                            : '所有服务'
                                                        : ''
                                                }`}
                                                {record.type !== PunishmentTypeEnum.TAKEOFF
                                                    ? `：${record.value}${
                                                          PunishmentTypeUnitCnEnumMap[record.type]
                                                      }`
                                                    : ''}
                                            </div>
                                        ))}
                                    </div>
                                    <div className="td">
                                        {PunishmentTargetCnEnum[item.target]}:
                                        {item.target === PunishmentTargetEnum.PROVIDER
                                            ? item.simpleProviderName
                                            : item.itemName}
                                    </div>
                                    <div className="td">
                                        <div>{item.violationType}</div>
                                        <div>{item.violationContent}</div>
                                    </div>
                                    <div className="td">{PunishmentStatusCnEnum[item.status]}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Score;
